/**
 * Initialize Magnific Popup for images and galleries
 */
export function initMagnificPopup() {
  if (window.jQuery && window.jQuery.fn.magnificPopup) {
    $('.image-popup').magnificPopup({
      type: 'image',
      gallery: {
        enabled: true
      }
    });

    $('.popup-gallery').magnificPopup({
      delegate: 'a',
      type: 'image',
      gallery: {
        enabled: true
      }
    });
  }
}